'use es6';

import PropTypes from 'prop-types';
import { useDialogState } from './DialogProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export const DialogRenderer = ({
  dialogTypeToDialog
}) => {
  const {
    openDialogs
  } = useDialogState();
  if (openDialogs.length === 0) {
    return null;
  }
  return openDialogs.reduce((dialogComponents, openDialog) => {
    const {
      dialogType,
      dialogProps
    } = openDialog;
    const Dialog = dialogTypeToDialog[dialogType];
    if (!Dialog) {
      console.error(`The component for dialogType \`${dialogType}\` is null / undefined. Did you forget to map a component to this dialogType?`);
      return dialogComponents;
    }
    dialogComponents.push( /*#__PURE__*/_jsx(Dialog, Object.assign({}, dialogProps), dialogType));
    return dialogComponents;
  }, []);
};
DialogRenderer.propTypes = {
  dialogTypeToDialog: PropTypes.object.isRequired
};